export default __webpack_public_path__ + "static/media/o-joshua.c82ec3fd.jpeg";